export default __webpack_public_path__ + "static/media/user_with_billing.b6a0b956.svg";